import React, { useState } from "react";
import { Button } from "@material-ui/core";
import useNotesPermissions from "../../../hooks/useNotesPermissions";
import NotesDrawer from "../NotesDrawer/NotesDrawer";

const ViewNotesButton = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setDrawerOpen(true)}
        className="view-notes-button"
      >
        View Notes
      </Button>
      <NotesDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </>
  );
};

export default ViewNotesButton;
